/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import Nominatim from 'Models/cadastros/Nominatim'
import ApiService from 'Services/ApiService'
import IFormNominatimFilter from 'Views/Cadastros/Geo/IFormNominatimFilter'

const geo = {
  getListNominatim: async (type: string, filter?: IFormNominatimFilter) => {
    const result: AxiosResponse<Nominatim[]> = await ApiService().get<
      Nominatim[]
    >(QueryStringFilter(`${hosts.WS_CADASTRO}/nominatim/${type}`, filter))

    return result
  },
}

export default geo
